import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=92365dba&scoped=true"
import script from "./Exception.vue?vue&type=script&lang=js"
export * from "./Exception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92365dba",
  null
  
)

export default component.exports